// Format inline text (handle **bold** within text)
const formatInlineText = (text) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={index} style={{ fontWeight: '600' }}>
          {part.slice(2, -2)}
        </strong>
      );
    }
    return part;
  });
};

// Format bot messages to handle markdown-like formatting
export const formatBotMessage = (text) => {
  // Split by double newlines for paragraphs
  const sections = text.split('\n\n').filter(Boolean);

  return sections.map((section, sectionIndex) => {
    const lines = section.split('\n').filter(Boolean);

    return (
      <div key={sectionIndex} style={{ marginBottom: '16px' }}>
        {lines.map((line, lineIndex) => {
          // Check for numbered list (1. 2. 3. etc)
          const numberedMatch = line.match(/^(\d+)\.\s+\*\*(.+?)\*\*:?$/);
          if (numberedMatch) {
            return (
              <div key={lineIndex} style={{ marginBottom: '12px', fontWeight: '600' }}>
                {numberedMatch[1]}. {numberedMatch[2]}
              </div>
            );
          }

          // Check for bullet points with bold text (- **text**:)
          const bulletBoldMatch = line.match(/^-\s+\*\*(.+?)\*\*:?(.*)$/);
          if (bulletBoldMatch) {
            return (
              <div key={lineIndex} style={{ marginLeft: '20px', marginBottom: '8px' }}>
                <span style={{ fontWeight: '600' }}>• {bulletBoldMatch[1]}</span>
                {bulletBoldMatch[2] && <span>: {bulletBoldMatch[2].trim()}</span>}
              </div>
            );
          }

          // Check for regular bullet points (-)
          const bulletMatch = line.match(/^-\s+(.+)$/);
          if (bulletMatch) {
            return (
              <div key={lineIndex} style={{ marginLeft: '20px', marginBottom: '6px' }}>
                • {formatInlineText(bulletMatch[1])}
              </div>
            );
          }

          // Regular line with possible bold text
          return (
            <div key={lineIndex} style={{ marginBottom: '6px' }}>
              {formatInlineText(line)}
            </div>
          );
        })}
      </div>
    );
  });
};
